import { Controller, useFormContext } from "react-hook-form";
import { VisualEmailTiptapEditor } from "./VisualEmailTiptapEditor";

export interface FormTipTapEditorProps {
  name: string;
  placeholder?: string;
}

export const FormTipTapEditor = ({
  name,
  placeholder = "Enter text...",
}: FormTipTapEditorProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value, onBlur } }) => (
        <VisualEmailTiptapEditor
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          shouldShowMenuBar
        />
      )}
    />
  );
};
